'use client'

import { useOptionalTenant } from '@/contexts/TenantContext'

export function useGeneralAiAvailable(): boolean {
    return useOptionalTenant()?.capabilities?.generalAi ?? true
}
